import React, { useState } from 'react';

import { Button } from './elements';
import { useClickStreamContext } from '../ClickStream';
import { UserApi } from 'api';

const Logout = () => {
  const { logPageEvent } = useClickStreamContext();
  const [loading, setLoading] = useState(false);
  const exit = async () => {
    if (loading) {
      return;
    }

    setLoading(true);

    try {
      await UserApi.logout();
      localStorage.setItem('UPR_logged', 'false');

      logPageEvent({
        eventType: 'user_logout',
        eventInfo: 'Пользователь разлогинился',
      });
      const basePath = process.env.REACT_APP_BASEURL || '';
      window.location.href = `${basePath}/main`;
    } catch {
      setLoading(false);
    }
  };

  return (
    <Button onClick={exit} data-qa-id="exitButton" data-testid="logout-button" aria-disabled={loading}>
      ВЫХОД
    </Button>
  );
};

export default Logout;
